import QueryButton from "./QueryButton";

export default QueryButton;
